import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@/app/store/hooks';
import { CookieNotice } from '@/shared/ui';

export function RegionGuard() {
  const regionFias = useAppSelector((state) => state.region.regionFias);

  if (!regionFias) {
    return <Navigate to="/region" replace />;
  }

  return (
    <>
      <Outlet />
      <CookieNotice />
    </>
  );
}
